module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwAQAAAAB/ecQqAAAAAnRSTlMAAHaTzTgAAAAaSURBVHgBY6AWYD5Adcr+//8/WCla2EclAABqEh8tob6sVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Importconfig/baseline_add_white_24dp.png
// module id = 155
// module chunks = 0